import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12.3725 11.6213C13.9412 11.6213 15 12.7132 15 14.3309C15 15.7868 13.7843 17 12.1373 17C10.3333 17 9 15.5441 9 13.3199C9 8.26471 12.6863 6.24265 15 6V8.22426C13.4314 8.50735 11.6667 10.0846 11.5882 11.8235C11.6667 11.7831 11.9804 11.6213 12.3725 11.6213Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SingleQuotesL"
);
